// DrawLab: toolbar entrypoints cho Share + Export image.
// Dùng window event thay atom để tránh xung đột jotai store giữa
// packages/excalidraw (editor-jotai) và excalidraw-app (app-jotai).
import { useEffect, useState } from "react";

import { useI18n } from "../i18n";
import { ExportImageIcon, DrawLabLinkIcon, tablerCheckIcon } from "./icons";
import { ToolButton } from "./ToolButton";
import { useExcalidrawSetAppState } from "./App";

export const DRAWLAB_OPEN_SHARE_EVENT = "drawlab:open-share";
export const DRAWLAB_SHARE_STATUS_EVENT = "drawlab:share-status";

export const openDrawLabShare = (mode: "direct" | "dialog" = "direct") => {
  window.dispatchEvent(
    new CustomEvent(DRAWLAB_OPEN_SHARE_EVENT, { detail: { mode } }),
  );
};

export const notifyDrawLabShareStatus = (status: "copied" | "idle") => {
  window.dispatchEvent(
    new CustomEvent(DRAWLAB_SHARE_STATUS_EVENT, { detail: { status } }),
  );
};

export const useDrawLabShareCopied = () => {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    let timeoutId: ReturnType<typeof setTimeout> | null = null;
    const onStatus = (event: Event) => {
      const detail = (event as CustomEvent<{ status?: string }>).detail;
      if (detail?.status !== "copied") {
        setCopied(false);
        return;
      }
      setCopied(true);
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      timeoutId = setTimeout(() => setCopied(false), 2200);
    };
    window.addEventListener(DRAWLAB_SHARE_STATUS_EVENT, onStatus);
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      window.removeEventListener(DRAWLAB_SHARE_STATUS_EVENT, onStatus);
    };
  }, []);

  return copied;
};

export const DrawLabToolbarActions = () => {
  const setAppState = useExcalidrawSetAppState();
  const shareCopied = useDrawLabShareCopied();
  const { t } = useI18n();

  return (
    <>
      <div className="App-toolbar__divider" />
      <ToolButton
        className="DrawLabToolbarActions__export"
        type="button"
        icon={ExportImageIcon}
        title={t("drawlab.exportImage")}
        aria-label={t("drawlab.exportImage")}
        data-testid="drawlab-toolbar-export"
        onClick={() => setAppState({ openDialog: { name: "imageExport" } })}
      />
      <ToolButton
        className="DrawLabToolbarActions__share"
        type="button"
        icon={shareCopied ? tablerCheckIcon : DrawLabLinkIcon}
        title={
          shareCopied ? t("drawlab.share.copied") : t("drawlab.share.title")
        }
        aria-label={
          shareCopied ? t("drawlab.share.copied") : t("drawlab.share.title")
        }
        data-testid="drawlab-toolbar-share"
        onClick={() => openDrawLabShare("direct")}
      />
    </>
  );
};
